(function () {
  var STORAGE_PREFIX = 'zjerseys_foo_offer_';

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function storageKey(root) {
    return root.dataset.fooStorageKey || STORAGE_PREFIX + 'v1';
  }

  function wasDismissed(root) {
    try {
      var raw = localStorage.getItem(storageKey(root));
      if (!raw) return false;
      var data = JSON.parse(raw);
      if (!data || !data.until) return false;
      return Date.now() < Number(data.until);
    } catch (e) {
      return false;
    }
  }

  function markDismissed(root) {
    try {
      var days = parseInt(root.dataset.fooDays || '7', 10);
      if (!days || days < 1) days = 7;
      var until = Date.now() + days * 24 * 60 * 60 * 1000;
      localStorage.setItem(storageKey(root), JSON.stringify({ until: until }));
    } catch (e) {
      /* ignore */
    }
  }

  function openPopup(root) {
    root.hidden = false;
    requestAnimationFrame(function () {
      root.classList.add('is-open');
    });
    document.documentElement.classList.add('foo-popup-open');
    document.body.classList.add('foo-popup-open');
    var cta = qs(root, '[data-foo-claim]');
    if (cta) cta.focus({ preventScroll: true });
  }

  function closePopup(root, persist) {
    root.classList.remove('is-open');
    document.documentElement.classList.remove('foo-popup-open');
    document.body.classList.remove('foo-popup-open');
    window.setTimeout(function () {
      root.hidden = true;
    }, 220);
    if (persist) markDismissed(root);
  }

  function copyCode(code) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).catch(function () {
        fallbackCopy(code);
      });
      return;
    }
    fallbackCopy(code);
  }

  function fallbackCopy(code) {
    try {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    } catch (e) {
      /* ignore */
    }
  }

  function bind(root) {
    if (root.dataset.fooBound === '1') return;
    root.dataset.fooBound = '1';

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-foo-close]')) {
        closePopup(root, true);
        return;
      }

      var claim = e.target.closest('[data-foo-claim]');
      if (!claim) return;

      var code = (root.dataset.fooCode || 'SAVE10').trim();
      if (!code) return;

      copyCode(code);
      if (typeof window.zjerseysApplyDiscount === 'function') {
        window.zjerseysApplyDiscount(code);
      }
      closePopup(root, true);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) {
        closePopup(root, true);
      }
    });
  }

  function armOpen(root, delay) {
    var opened = false;
    var readyAt = Date.now() + delay;
    var fallbackMs = Math.max(delay + 8000, 12000);

    function tryOpen() {
      if (opened) return;
      if (Date.now() < readyAt) return;
      opened = true;
      detach();
      openPopup(root);
    }

    function onGesture() {
      tryOpen();
    }

    function detach() {
      window.removeEventListener('scroll', onGesture, true);
      window.removeEventListener('pointerdown', onGesture, true);
      window.removeEventListener('keydown', onGesture, true);
      window.removeEventListener('touchstart', onGesture, true);
    }

    /* 等用户有交互再弹，避免 PSI 实验室 CLS；真实用户滚动/点击仍会看到 */
    window.addEventListener('scroll', onGesture, { capture: true, passive: true });
    window.addEventListener('pointerdown', onGesture, true);
    window.addEventListener('keydown', onGesture, true);
    window.addEventListener('touchstart', onGesture, { capture: true, passive: true });

    window.setTimeout(tryOpen, fallbackMs);
  }

  function autoClaim(root) {
    var code = (root.dataset.fooCode || 'SAVE10').trim();
    if (!code) return;
    if (root.dataset.fooClaimed === '1') return;
    root.dataset.fooClaimed = '1';
    /* 顶栏已写 First order $10 OFF：进页就后台领券，不等人点 Claim */
    if (typeof window.zjerseysApplyDiscount === 'function') {
      window.zjerseysApplyDiscount(code);
    }
  }

  function initOne(root) {
    if (!root) return;
    autoClaim(root);
    if (wasDismissed(root)) return;
    bind(root);
    var delay = parseInt(root.dataset.fooDelay || '0', 10);
    if (isNaN(delay) || delay < 0) delay = 0;
    armOpen(root, delay);
  }

  function initAll() {
    document.querySelectorAll('[data-foo-popup]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
